import IconComponent from "icons/IconComponent";

import TwitterIcon from "./twitter-icon.svg";

export default (TwitterIcon as any) as IconComponent;
